
import { Options, Vue } from "vue-class-component";
import Row from "./Row.vue";

@Options({
    components: {
        Row,
    },
    props: {
        currentRowIndex: Number,
    },
})
export default class Grid extends Vue {
    rows = [];
    currentRowIndex!: number;

    get expressions(): string[][] {
        return this.$store.state.expressions;
    }
}
